import { fetcher } from '@commenda/utils';
import {
  BulkDeleteTransactionsByIdsResponse,
  BulkExportReportType,
  BulkExportTransactionsRequest,
} from './types';

export async function bulkExportTransactions(
  body: BulkExportTransactionsRequest,
  extend?: BulkExportReportType | undefined
): Promise<{
  success: boolean;
  error?: string;
  data?: BulkDeleteTransactionsByIdsResponse;
}> {
  try {
    const url = extend
      ? `new-sales-tax/transactions/bulk/export?extend=${extend}`
      : `new-sales-tax/transactions/bulk/export`;
    const response = await fetcher(
      url,
      {
        method: 'POST',
        body,
      },
      undefined
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to export transactions',
      };
    }

    const data = await response.json();

    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to export transactions';
    return {
      success: false,
      error: errorMessage,
    };
  }
}
